import {compose} from 'redux';
import withUsers from '../../../_common/components/Users/components/withUsers';
import InspectionDetails from './InspectionDetails';

export default compose(
  withUsers,
)(InspectionDetails);
